import { Flex, Avatar, Box, Text, Icon } from '@chakra-ui/react';
import { NotificationCard } from '../components/Card';
import { NotificationTime } from '../components/Time';
import RoleChangeIcon from '@/assets/icons/notification/RoleChange';
import { selectCurrUser } from '@/store/bootstrap/selectors';
import { useSelector } from 'react-redux';
import { decode } from 'js-base64';

export const RoleChange = ({ notification = {} }) => {
  const currUser = useSelector(selectCurrUser);
  const { custom_attributes } = notification;
  const data = JSON.parse(decode(custom_attributes));

  return (
    <NotificationCard notification={notification}>
      <Flex>
        <Box>
          <Box height="40px" pos="relative">
            <Avatar
              width="36px"
              height="36px"
              borderRadius="8px"
              className="avatar-md"
              name={currUser?.first_name}
              src={currUser?.avatar}
              data-test-id="avatar-current-user"
            />
            <Box pos="absolute" bottom="-24px" left="9px">
              <Icon as={RoleChangeIcon} width="40px" height="40px" />
            </Box>
          </Box>
        </Box>
        <Box ml="12px">
          <Text>
            <Text as="span" px="4px">
              <Text as="span" pr="4px" fontWeight={800}>
                Your
              </Text>
              role has changed from
              <Text
                as="span"
                px="4px"
                fontWeight={800}
                display="inline-block"
                textTransform="capitalize"
              >
                {data?.role_change[0]}
              </Text>
              to
              <Text
                as="span"
                px="4px"
                textTransform="capitalize"
                fontWeight={800}
                display="inline-block"
              >
                {data?.role_change[1]}
              </Text>
            </Text>
          </Text>
          <NotificationTime notification={notification} />
        </Box>
      </Flex>
    </NotificationCard>
  );
};
